var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{staticClass:"app-next-link",attrs:{"href":_vm.href,"title":"Open the new Drive Scout app","data-testid":"app-next-link"},on:{"click":_vm.handOff,"auxclick":_vm.openGate}},[_vm._v("\n  New App\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }